/**
 * Created by Mark on 18/04/2017.
 */


import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/create-class-steps';
import {Breadcrumb} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
export default class ClassesWizardComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return (<Layout>
            <div className="test-highlight four-zero">
                <div className="palette-White bg fz-inner">
                    <h4><FormattedMessage id={ 'ui-650' } defaultMessage={ 'Coming Soon!' }/></h4>
                </div>
            </div>
        </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/comming-soon.js